import React from "react";

const QUOTES = [
  {
    q: "No crash, just focus. I work through the whole morning.",
    a: "Amira K.",
    role: "Product designer",
  },
  {
    q: "Feels clean, not wired. First coffee that actually calms me.",
    a: "Jonas R.",
    role: "Founder",
  },
  {
    q: "Best coffee for long work sessions. My desk companion now.",
    a: "Hira M.",
    role: "Writer",
  },
  {
    q: "Tastes premium. Effect is noticeably smoother than espresso.",
    a: "Theo V.",
    role: "Software engineer",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-36 bg-[color:var(--fs-surface)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-6">
            <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
              07 / In the Cup
            </span>
            <h2
              className="mt-4 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white"
              data-testid="testimonials-heading"
            >
              The Feeling,
              <br />
              <span className="italic text-gold-foil">in their words.</span>
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-neutral-400 text-base leading-relaxed max-w-md">
              We don't tell you what to feel. These are unedited notes from
              early drinkers of Flow State.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {QUOTES.map((t, i) => (
            <figure
              key={t.a}
              className={`card-gold p-8 md:p-10 rounded-[2px] ${
                i % 2 === 0 ? "md:translate-y-0" : "md:translate-y-10"
              }`}
              data-testid={`testimonial-${i}`}
            >
              <div className="font-display text-4xl text-[color:var(--fs-gold-muted)] leading-none">
                "
              </div>
              <blockquote className="mt-3 font-display italic text-2xl md:text-3xl text-white leading-snug">
                {t.q}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <span className="h-[1px] w-6 bg-[color:var(--fs-gold-muted)]" />
                <span className="text-[11px] tracking-[0.24em] uppercase text-neutral-400">
                  {t.a} · {t.role}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
